import React from "react";

const RemoveAccountIcon = () => {
  return (
    <svg
      viewBox="0 0 330.74 328.24"
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
    >
      <g fillRule="evenodd">
        <path
          d="m319.31 164.74a155.78 155.78 0 1 1 -311.57 0 155.78 155.78 0 1 1 311.57 0z"
          fill="#c00000"
          strokeWidth="18.75"
        />
        <g fill="#fff" strokeWidth="1.25">
          <path d="m292.62 145.83a131.71 137.25 0 0 1 0 47.667l-129.71-23.834 129.71-23.834z" />
          <path d="m40.686 193.49" />
          <rect x="41.894" y="146.05" width="250.14" height="47.563" />
        </g>
      </g>
    </svg>
  );
};
export default RemoveAccountIcon;
